import React from 'react';
import clsx from 'clsx';

import classes from './link.module.scss';

export type LinkProps = React.ComponentProps<'a'>;

export const Link = (props: LinkProps) => {
  return <a {...props} className={clsx(props.className, classes.link)} />;
};
